import { paths } from '../../common/constants/pathVariables.js';
import {
  SubscriptionAddOnGroup,
  SubscriptionAdditionalServiceStatusEnum,
  SubscriptionAddonCode,
} from '../../common/enums.js';
import { t } from '../../common/i18n/index.js';
import type { AddedAddon } from '../../common/types/addon';
import type { AddOnVisibility } from '../../generated/api/addOnVisibility.js';
import type { Subscription } from '../../generated/api/subscription';

export const showAddonAsLink = (
  additionalServicePath?: string,
  isEmployee?: boolean,
  serviceStatus?: SubscriptionAdditionalServiceStatusEnum
): boolean =>
  Boolean(serviceStatus !== SubscriptionAdditionalServiceStatusEnum.NOT_IN_USE && additionalServicePath && !isEmployee);

export const shouldNotShowMobileId = (
  isEmployee: boolean,
  isMobileIdEnabledForCompany: boolean,
  isMobileIdEnabledForEoeUser: boolean
) => {
  return (!isEmployee && !isMobileIdEnabledForCompany) || (isEmployee && !isMobileIdEnabledForEoeUser);
};

export enum AdditionalInformationCategory {
  FIXED_BROADBAND = 'FIXED_BROADBAND',
  ALL = 'ALL',
}

export const getInformationCategoryFromPath = (path: string): AdditionalInformationCategory => {
  const pathname = decodeURI(path);
  if (pathname.startsWith(paths.ANONYMOUS_FIXED_BROADBAND_ORDER)) {
    return AdditionalInformationCategory.FIXED_BROADBAND;
  }
  return AdditionalInformationCategory.ALL;
};

interface AddOnAdditionalInformationType {
  addOnCode?: string;
  addOnGroup?: string;
  information: string;
  categories: AdditionalInformationCategory[];
}

export const getAddOnAdditionalInformationMap = (): AddOnAdditionalInformationType[] => [
  {
    addOnGroup: SubscriptionAddOnGroup.PUBLIC_IP,
    information: t.CCRE(
      'All Netti Lite 4G/5G subscriptions are included with a secure, non-public IP address by default. If you need a public IP address, can you order it as an additional service.'
    ),
    categories: [AdditionalInformationCategory.FIXED_BROADBAND],
  },
];

export const includesVoiceMail = (subscription: Subscription): boolean =>
  Boolean(subscription.details?.selectedAddOns?.some(addon => addon.addOnCode === SubscriptionAddonCode.VOICE_MAIL));

export const getNonEditableAddOns = (addOnVisibilities: AddOnVisibility[], addOns: AddedAddon[]): AddedAddon[] => {
  const visibilityGuids = new Set(addOnVisibilities.map(({ addOnGuidCode }) => addOnGuidCode));
  return addOns.filter(({ addOnCode }) => !visibilityGuids.has(addOnCode));
};
